var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeScanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "badge-scan-icon",
    transform: "translate(-536 -94)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(536 94)",
    fill: "#9cdbd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19170",
    "data-name": "Path 19170",
    d: "M108.741,24.618a1.027,1.027,0,0,1-1.027,1.027h-5.677V30h5.677a5.389,5.389,0,0,0,5.382-5.382v-5.5h-4.355ZM107.714,0h-5.677V4.355h5.677a1.023,1.023,0,0,1,1.027,1.027v6.223H113.1V5.382A5.389,5.389,0,0,0,107.714,0M87.451,24.618v-5.5H83.1v5.5A5.389,5.389,0,0,0,88.478,30h6.049V25.645H88.478a1.031,1.031,0,0,1-1.027-1.027M83.1,5.382v6.223h4.355V5.382a1.027,1.027,0,0,1,1.027-1.027h6.049V0H88.478A5.389,5.389,0,0,0,83.1,5.382",
    transform: "translate(482.904 124)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeScanIcon);
export default __webpack_public_path__ + "static/media/badge-scan-icon.71ff5f95.svg";
export { ForwardRef as ReactComponent };